import { escapeHtml } from '../ui.js';
import { reassignList } from '../tasks-v2.js';

// PICK A PERSON (design_handoff_tasks_v2: "Reassign is a plain list with open
// counts. The capacity picker goes.")
//
// One list, two uses, both inside the task panel: Reassign (Unassigned offered
// last) and Send for check (the assignee left off — nobody checks their own
// work). The figure beside each name is how many open tasks they hold; there is
// no load bar, because the load figure read estimates nobody sets.

/**
 * @param opts.mode     'assign' | 'check'
 * @param opts.task     the task being moved
 * @param opts.tasks    the open work, for the counts
 * @param opts.people   the team
 */
export function pickerRows({ mode = 'assign', task = {}, tasks = [], people = [] } = {}) {
  const current = mode === 'check' ? task.checkerId : task.assigneeId;
  const rows = reassignList(tasks, people, current || null);
  return mode === 'check' ? rows.filter((r) => r.person.userId !== task.assigneeId) : rows;
}

export function pickerHtml({ mode = 'assign', task = {}, tasks = [], people = [] } = {}) {
  const rows = pickerRows({ mode, task, tasks, people });
  const heading = mode === 'check' ? 'Send for check to' : 'Reassign to';
  const item = (value, name, meta, current) => `<button type="button" class="tk2-pick${current ? ' on' : ''}"
      data-pick="${escapeHtml(value)}"${current ? ' aria-current="true"' : ''}>
      <span class="tk2-pick-n">${escapeHtml(name)}</span>
      <span class="tk2-pick-m">${escapeHtml(meta)}</span>
    </button>`;
  return `<div class="tk2-picker" role="group" aria-label="${escapeHtml(heading)}">
    <div class="tk2-step-head"><span class="tk2-eb">${escapeHtml(heading)}</span>
      <button type="button" class="tk2-link" data-step-cancel>Cancel</button></div>
    <div class="tk2-pick-list">
      ${rows.map((r) => item(r.person.userId, r.person.name,
        `${r.open} open${r.current ? (mode === 'check' ? ' · checking now' : ' · has it now') : ''}`, r.current)).join('')
        || '<p class="tk2-empty">Nobody else on the team.</p>'}
      ${mode === 'assign' ? item('', 'Unassigned', task.assigneeId ? 'Back to the team meeting' : 'Unassigned now', !task.assigneeId) : ''}
    </div>
  </div>`;
}
